import apiClient from '@/shared/api/client';
import type { ApiResponse } from '@/shared/api/types';
import type { CommunicationPreference, CommunicationPreferencePatch } from '@/modules/agents/utils/commsLabels';

/** The Command Center door onto CommunicationPreference (practiceId × agentType). */
export const commsApi = {
  list: async (practiceId: string): Promise<CommunicationPreference[]> => {
    const { data } = await apiClient.get<ApiResponse<CommunicationPreference[]>>(
      `/agency/practices/${practiceId}/comms`,
    );
    return data.data;
  },

  update: async (
    practiceId: string,
    agentType: string,
    patch: CommunicationPreferencePatch,
  ): Promise<CommunicationPreference> => {
    const { data } = await apiClient.put<ApiResponse<CommunicationPreference>>(
      `/agency/practices/${practiceId}/comms/${encodeURIComponent(agentType)}`,
      patch,
    );
    return data.data;
  },
};
